import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { API_BASE_URL } from '../../api';

export default function ClientsSection() {
  const [clients, setClients] = useState([]);
  const [newClient, setNewClient] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchClients = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/clients`);
      setClients(res.data);
    } catch { toast.error('Failed to load clients'); }
  }, []);
  useEffect(() => { fetchClients(); }, [fetchClients]);

  const add = async () => {
    if (!newClient.trim()) return toast.error('Client name required');
    if (clients.some((c) => c.name.toLowerCase() === newClient.trim().toLowerCase())) return toast.error('Client already exists');
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/clients`, { name: newClient.trim() });
      setNewClient('');
      fetchClients();
      toast.success('Client added');
    } catch { toast.error('Failed to add client'); }
    setLoading(false);
  };

  return (
    <div>
      <div className="flex mb-4">
        <input type="text" value={newClient} onChange={(e) => setNewClient(e.target.value)}
          placeholder="New client name" className="border p-2 rounded mr-2 text-black" />
        <button onClick={add} className="bg-blue-500 text-white px-4 py-2 rounded" disabled={loading}>Add</button>
      </div>
      <table className="min-w-full border-collapse">
        <thead><tr><th className="border p-2 text-left">ID</th><th className="border p-2 text-left">Name</th></tr></thead>
        <tbody>
          {clients.map((c) => (
            <tr key={c.id}><td className="border p-2">{c.id}</td><td className="border p-2">{c.name}</td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
